const lerp = (a, b, n) => (1 - n) * a + n * b;
const getRandomInteger = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

export {
  lerp,
  getRandomInteger,
};
